import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { getDismissedBannerIds } from "@/components/restaurant/BannerAd";

interface Banner {
  id: string;
  campaign_name: string;
  company_name: string;
  image_url: string;
  target_url: string;
  position: string;
  target_cities: string[] | null;
}

export function useBanners(currentCityId?: string | null, enabled = true) {
  return useQuery({
    queryKey: ["active-banners", currentCityId],
    enabled,
    queryFn: async () => {
      // RLS policy already filters for active banners within date range
      const { data, error } = await supabase
        .from("banners")
        .select("id, campaign_name, company_name, image_url, target_url, position, target_cities");

      if (error) throw error;
      
      // Filter by city and dismissed banners
      const today = new Date().toISOString().split("T")[0];
      const dismissedIds = getDismissedBannerIds();
      const filteredData = (data || []).filter((banner: any) => {
        if (dismissedIds.includes(banner.id)) return false;
        if (banner.is_active === false) return false;
        if (banner.start_date && banner.start_date > today) return false;
        if (banner.end_date && banner.end_date < today) return false;
        if (banner.target_cities === null) return true;
        if (!currentCityId) return true;
        return banner.target_cities.includes(currentCityId);
      });
      
      // Group by position
      const bannersByPosition: Record<string, Banner> = {};
      filteredData.forEach((banner: Banner) => {
        // Only keep one banner per position (first one)
        if (!bannersByPosition[banner.position]) {
          bannersByPosition[banner.position] = banner;
        }
      });
      
      return bannersByPosition;
    },
    staleTime: 10 * 60 * 1000, // 10 perc - bannerek ritkán változnak
    gcTime: 60 * 60 * 1000, // 1 óra cache
  });
}
